import { render, staticRenderFns } from "./approval-records.vue?vue&type=template&id=68d9b520&scoped=true&"
import script from "./approval-records.vue?vue&type=script&lang=js&"
export * from "./approval-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9b520",
  null
  
)

export default component.exports